import { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import useQuery from 'hooks/useQuery'
import { filterEmptyValues } from 'utils/helpers'
import { Button, TextInput, StoreSelect } from 'components/common'
import { Dropdown } from 'components/common'
import {
  FILTER_FIELD_PURCHASE_TIMER,
  PURCHASE_TIMER_FORM_FIELDS,
} from './utils'

const { BARCODE, STORE, AVAILABLE_TO_PURCHASE_TIMER } =
  PURCHASE_TIMER_FORM_FIELDS

type Props = {
  toggleFilterForm: () => void
}

const PurchaseTimerFilterForm = ({ toggleFilterForm }: Props) => {
  const { getQuery, removeQuery, setMultipleQueries } = useQuery()
  const filters = getQuery(FILTER_FIELD_PURCHASE_TIMER)
  const { register, handleSubmit, reset, setValue } = useForm({
    defaultValues: filters,
  })

  const onFilterApply = (data: any) => {
    if (data?.availableToPurchaseTimer === 'NONE')
      delete data.availableToPurchaseTimer

    const filteredData = filterEmptyValues(data)

    if (Object.values(filteredData).length > 0) {
      setMultipleQueries({
        [FILTER_FIELD_PURCHASE_TIMER]: filteredData,
        page: 1,
      })
    } else {
      removeQuery(FILTER_FIELD_PURCHASE_TIMER)
    }

    toggleFilterForm()
  }

  const cancelFilter = () => {
    reset(filters)
    toggleFilterForm()
  }

  useEffect(() => {
    reset(filters)
  }, [])

  return (
    <div className="mt-2 rounded-lg border bg-white px-5 py-3">
      <div className="mx-auto max-w-5xl">
        <form onSubmit={handleSubmit(onFilterApply)}>
          <div className="grid grid-cols-2 gap-x-14 gap-y-3 md:grid-cols-3">
            <TextInput
              register={register}
              name={BARCODE.key}
              label={BARCODE.label}
            />

            <StoreSelect
              name={STORE.key}
              label={STORE.label}
              setValue={setValue}
              defaultValue={filters?.[STORE.key]}
            />

            <Dropdown
              name={AVAILABLE_TO_PURCHASE_TIMER.key}
              label={AVAILABLE_TO_PURCHASE_TIMER.label}
              setValue={setValue}
              defaultValue={filters?.[AVAILABLE_TO_PURCHASE_TIMER.key]}
              options={[
                { label: '--- NONE ---', value: 'NONE', disabled: false },
                { label: 'Yes', value: 'true', disabled: false },
                { label: 'No', value: 'false', disabled: false },
              ]}
            />
          </div>

          <div className="my-4 flex gap-5">
            <Button buttonText="Apply Filters" className="w-32" />
            <Button
              type="button"
              buttonText="Cancel"
              variant="outline"
              onClick={cancelFilter}
              className="w-32"
            />
          </div>
        </form>
      </div>
    </div>
  )
}

export default PurchaseTimerFilterForm
